import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL } from './urls'

// 分类组别列表
async function all (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match`,
      method: 'GET'
    }
  )
}

async function getById (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match/${data.id}`,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/stage/${data.stageId}/match/${data.id}`,
      method: 'DELETE'
    }
  )
}

export default {
  all,
  getById,
  insert,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-competition-stage-match.js